var color = {
  primary: "#f1f1f0",
  onPrimary: "#000000",
  primaryLight: "#ffffff",
  onPrimaryLight: "#000000",
  primaryDark: "#bebebe",
  onPrimaryDark: "#000000",
  secondary: "#ddcb91",
  onSecondary: "#000000",
  secondaryLight: "#fffec2",
  onSecondaryLight: "#000000",
  secondaryDark: "#aa9a63",
  onSecondaryDark: "#000000",
  background: "#121212",
  onBackground: "#ffffff",
  surface: "#333333",
  onSurface: "#ffffff",
  highlight: "#ffffff",
  highEmphasis: "#fafafa",
  mediumEmphasis: "#bbbbbb",
  lowEmphasis: "#777777",
  link: "#227bbd",
  onLink: "#ffffff",
  success: "#569a32",
  onSuccess: "#ffffff",
  warning: "#fcc433",
  onWarning: "#333333",
  alert: "#e74627",
  onAlert: "#ffffff"
};
var borderRadius = {
  none: 0,
  small: 2,
  medium: 4,
  large: 8
};
var button = {
  "default": {
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: 1.23,
    lineHeight: 1.5
  }
};
var heading1 = {
  fontSize: 96,
  fontWeight: 400,
  letterSpacing: 0
};
var heading2 = {
  fontSize: 60,
  fontWeight: 400,
  letterSpacing: 0
};
var heading3 = {
  fontSize: 48,
  fontWeight: 400,
  letterSpacing: 0
};
var heading4 = {
  fontSize: 34,
  fontWeight: 400,
  letterSpacing: 0.27
};
var heading5 = {
  fontSize: 24,
  fontWeight: 400,
  letterSpacing: 0
};
var heading6 = {
  fontSize: 20,
  fontWeight: 500,
  letterSpacing: 0.24
};
var subtitle1 = {
  fontSize: 16,
  fontWeight: 500,
  letterSpacing: 0.13
};
var subtitle2 = {
  fontSize: 14,
  fontWeight: 500,
  letterSpacing: 0.11
};
var body1 = {
  fontSize: 16,
  fontWeight: 400,
  letterSpacing: 0.51
};
var body2 = {
  fontSize: 14,
  fontWeight: 400,
  letterSpacing: 0.22
};
var caption = {
  fontSize: 12,
  fontWeight: 400,
  letterSpacing: 0.38
};
var overline = {
  fontSize: 12,
  fontWeight: 500,
  letterSpacing: 1.92
};
var opacity = {
  transparent: 0,
  lower: 0.04,
  veryLow: 0.08,
  low: 0.12,
  mediumLow: 0.16,
  disabledLow: 0.24,
  disabled: 0.32,
  medium: 0.48,
  mediumHigh: 0.56,
  high: 0.64,
  veryHigh: 0.8,
  opaque: 1
};
var size = {
  none: 0,
  micro: 4,
  tiny: 8,
  small: 16,
  standard: 24,
  semi: 32,
  semiX: 40,
  medium: 48,
  mediumX: 56,
  large: 64,
  largeX: 72,
  largeXX: 80,
  largeXXX: 88,
  huge: 96,
  hugeX: 128,
  hugeXX: 144,
  hugeXXX: 192,
  veryHuge: 256
};
var typography = {
  fontFamily: {
    primary: "Roboto",
    secondary: "sans-serif",
    branding: "Helvetica Now",
    code: "Roboto Mono"
  },
  lineHeight: {
    reset: 1,
    small: 1.25,
    medium: 1.5,
    large: 2
  },
  fontWeight: {
    regular: 400,
    medium: 500
  }
};
var spacing = {
  none: 0,
  micro: 4,
  tiny: 8,
  small: 16,
  standard: 24,
  semi: 32,
  large: 48,
  xLarge: 64
};
var elevation = {
  none: "none",
  micro: "0 1px 1px 0 rgba(0, 0, 0, 0.14)",
  tiny: "0 2px 2px 0 rgba(0, 0, 0, 0.14)",
  small: "0 3px 4px 0 rgba(0, 0, 0, 0.14)",
  medium: "0 4px 5px 0 rgba(0, 0, 0, 0.14)",
  large: "0 6px 10px 0 rgba(0, 0, 0, 0.14)",
  largeX: "0 8px 10px 0 rgba(0, 0, 0, 0.14)",
  largeXX: "0 9px 12px 0 rgba(0, 0, 0, 0.14)",
  huge: "0 12px 17px 0 rgba(0, 0, 0, 0.14)",
  hugeX: "0 16px 24px 0 rgba(0, 0, 0, 0.14)",
  hugeXX: "0 24px 38px 0 rgba(0, 0, 0, 0.14)"
};
var aesopDarkTheme = {
  color: color,
  borderRadius: borderRadius,
  button: button,
  heading1: heading1,
  heading2: heading2,
  heading3: heading3,
  heading4: heading4,
  heading5: heading5,
  heading6: heading6,
  subtitle1: subtitle1,
  subtitle2: subtitle2,
  body1: body1,
  body2: body2,
  caption: caption,
  overline: overline,
  opacity: opacity,
  size: size,
  typography: typography,
  spacing: spacing,
  elevation: elevation
};
var color$1 = {
  primary: "#262625",
  onPrimary: "#ffffff",
  primaryLight: "#4e4e4d",
  onPrimaryLight: "#ffffff",
  primaryDark: "#000000",
  onPrimaryDark: "#ffffff",
  secondary: "#a6662b",
  onSecondary: "#ffffff",
  secondaryLight: "#db9457",
  onSecondaryLight: "#000000",
  secondaryDark: "#733b00",
  onSecondaryDark: "#ffffff",
  background: "#fafafa",
  onBackground: "#333333",
  surface: "#ffffff",
  onSurface: "#333333",
  highlight: "#000000",
  highEmphasis: "#333333",
  mediumEmphasis: "#777777",
  lowEmphasis: "#bbbbbb",
  link: "#227bbd",
  onLink: "#ffffff",
  success: "#569a32",
  onSuccess: "#ffffff",
  warning: "#fcc433",
  onWarning: "#333333",
  alert: "#e74627",
  onAlert: "#ffffff"
};
var borderRadius$1 = {
  none: 0,
  small: 2,
  medium: 4,
  large: 8
};
var button$1 = {
  "default": {
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: 1.23,
    lineHeight: 1.5
  }
};
var heading1$1 = {
  fontSize: 96,
  fontWeight: 400,
  letterSpacing: 0
};
var heading2$1 = {
  fontSize: 60,
  fontWeight: 400,
  letterSpacing: 0
};
var heading3$1 = {
  fontSize: 48,
  fontWeight: 400,
  letterSpacing: 0
};
var heading4$1 = {
  fontSize: 34,
  fontWeight: 400,
  letterSpacing: 0.27
};
var heading5$1 = {
  fontSize: 24,
  fontWeight: 400,
  letterSpacing: 0
};
var heading6$1 = {
  fontSize: 20,
  fontWeight: 500,
  letterSpacing: 0.24
};
var subtitle1$1 = {
  fontSize: 16,
  fontWeight: 500,
  letterSpacing: 0.13
};
var subtitle2$1 = {
  fontSize: 14,
  fontWeight: 500,
  letterSpacing: 0.11
};
var body1$1 = {
  fontSize: 16,
  fontWeight: 400,
  letterSpacing: 0.51
};
var body2$1 = {
  fontSize: 14,
  fontWeight: 400,
  letterSpacing: 0.22
};
var caption$1 = {
  fontSize: 12,
  fontWeight: 400,
  letterSpacing: 0.38
};
var overline$1 = {
  fontSize: 12,
  fontWeight: 500,
  letterSpacing: 1.92
};
var opacity$1 = {
  transparent: 0,
  lower: 0.04,
  veryLow: 0.08,
  low: 0.12,
  mediumLow: 0.16,
  disabledLow: 0.24,
  disabled: 0.32,
  medium: 0.48,
  mediumHigh: 0.56,
  high: 0.64,
  veryHigh: 0.8,
  opaque: 1
};
var size$1 = {
  none: 0,
  micro: 4,
  tiny: 8,
  small: 16,
  standard: 24,
  semi: 32,
  semiX: 40,
  medium: 48,
  mediumX: 56,
  large: 64,
  largeX: 72,
  largeXX: 80,
  largeXXX: 88,
  huge: 96,
  hugeX: 128,
  hugeXX: 144,
  hugeXXX: 192,
  veryHuge: 256
};
var typography$1 = {
  fontFamily: {
    primary: "Roboto",
    secondary: "sans-serif",
    branding: "Helvetica Now",
    code: "Roboto Mono"
  },
  lineHeight: {
    reset: 1,
    small: 1.25,
    medium: 1.5,
    large: 2
  },
  fontWeight: {
    regular: 400,
    medium: 500
  }
};
var spacing$1 = {
  none: 0,
  micro: 4,
  tiny: 8,
  small: 16,
  standard: 24,
  semi: 32,
  large: 48,
  xLarge: 64
};
var elevation$1 = {
  none: "none",
  micro: "0 1px 1px 0 rgba(0, 0, 0, 0.14)",
  tiny: "0 2px 2px 0 rgba(0, 0, 0, 0.14)",
  small: "0 3px 4px 0 rgba(0, 0, 0, 0.14)",
  medium: "0 4px 5px 0 rgba(0, 0, 0, 0.14)",
  large: "0 6px 10px 0 rgba(0, 0, 0, 0.14)",
  largeX: "0 8px 10px 0 rgba(0, 0, 0, 0.14)",
  largeXX: "0 9px 12px 0 rgba(0, 0, 0, 0.14)",
  huge: "0 12px 17px 0 rgba(0, 0, 0, 0.14)",
  hugeX: "0 16px 24px 0 rgba(0, 0, 0, 0.14)",
  hugeXX: "0 24px 38px 0 rgba(0, 0, 0, 0.14)"
};
var aesopLightTheme = {
  color: color$1,
  borderRadius: borderRadius$1,
  button: button$1,
  heading1: heading1$1,
  heading2: heading2$1,
  heading3: heading3$1,
  heading4: heading4$1,
  heading5: heading5$1,
  heading6: heading6$1,
  subtitle1: subtitle1$1,
  subtitle2: subtitle2$1,
  body1: body1$1,
  body2: body2$1,
  caption: caption$1,
  overline: overline$1,
  opacity: opacity$1,
  size: size$1,
  typography: typography$1,
  spacing: spacing$1,
  elevation: elevation$1
};
var color$2 = {
  primary: "#f091c9",
  onPrimary: "#000000",
  primaryLight: "#ffc3fc",
  onPrimaryLight: "#000000",
  primaryDark: "#bc6198",
  onPrimaryDark: "#000000",
  secondary: "#e9e9e9",
  onSecondary: "#333333",
  secondaryLight: "#ffffff",
  onSecondaryLight: "#333333",
  secondaryDark: "#b7b7b7",
  onSecondaryDark: "#333333",
  background: "#121212",
  onBackground: "#ffffff",
  surface: "#333333",
  onSurface: "#ffffff",
  highlight: "#ffffff",
  highEmphasis: "#fafafa",
  mediumEmphasis: "#bbbbbb",
  lowEmphasis: "#777777",
  link: "#227bbd",
  onLink: "#ffffff",
  success: "#569a32",
  onSuccess: "#ffffff",
  warning: "#fcc433",
  onWarning: "#333333",
  alert: "#e74627",
  onAlert: "#ffffff"
};
var borderRadius$2 = {
  none: 0,
  small: 2,
  medium: 4,
  large: 8
};
var button$2 = {
  "default": {
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: 1.23,
    lineHeight: 1.5
  }
};
var heading1$2 = {
  fontSize: 96,
  fontWeight: 400,
  letterSpacing: 0
};
var heading2$2 = {
  fontSize: 60,
  fontWeight: 400,
  letterSpacing: 0
};
var heading3$2 = {
  fontSize: 48,
  fontWeight: 400,
  letterSpacing: 0
};
var heading4$2 = {
  fontSize: 34,
  fontWeight: 400,
  letterSpacing: 0.27
};
var heading5$2 = {
  fontSize: 24,
  fontWeight: 400,
  letterSpacing: 0
};
var heading6$2 = {
  fontSize: 20,
  fontWeight: 500,
  letterSpacing: 0.24
};
var subtitle1$2 = {
  fontSize: 16,
  fontWeight: 500,
  letterSpacing: 0.13
};
var subtitle2$2 = {
  fontSize: 14,
  fontWeight: 500,
  letterSpacing: 0.11
};
var body1$2 = {
  fontSize: 16,
  fontWeight: 400,
  letterSpacing: 0.51
};
var body2$2 = {
  fontSize: 14,
  fontWeight: 400,
  letterSpacing: 0.22
};
var caption$2 = {
  fontSize: 12,
  fontWeight: 400,
  letterSpacing: 0.38
};
var overline$2 = {
  fontSize: 12,
  fontWeight: 500,
  letterSpacing: 1.92
};
var opacity$2 = {
  transparent: 0,
  lower: 0.04,
  veryLow: 0.08,
  low: 0.12,
  mediumLow: 0.16,
  disabledLow: 0.24,
  disabled: 0.32,
  medium: 0.48,
  mediumHigh: 0.56,
  high: 0.64,
  veryHigh: 0.8,
  opaque: 1
};
var size$2 = {
  none: 0,
  micro: 4,
  tiny: 8,
  small: 16,
  standard: 24,
  semi: 32,
  semiX: 40,
  medium: 48,
  mediumX: 56,
  large: 64,
  largeX: 72,
  largeXX: 80,
  largeXXX: 88,
  huge: 96,
  hugeX: 128,
  hugeXX: 144,
  hugeXXX: 192,
  veryHuge: 256
};
var typography$2 = {
  fontFamily: {
    primary: "Roboto",
    secondary: "sans-serif",
    branding: "Helvetica Now",
    code: "Roboto Mono"
  },
  lineHeight: {
    reset: 1,
    small: 1.25,
    medium: 1.5,
    large: 2
  },
  fontWeight: {
    regular: 400,
    medium: 500
  }
};
var spacing$2 = {
  none: 0,
  micro: 4,
  tiny: 8,
  small: 16,
  standard: 24,
  semi: 32,
  large: 48,
  xLarge: 64
};
var elevation$2 = {
  none: "none",
  micro: "0 1px 1px 0 rgba(0, 0, 0, 0.14)",
  tiny: "0 2px 2px 0 rgba(0, 0, 0, 0.14)",
  small: "0 3px 4px 0 rgba(0, 0, 0, 0.14)",
  medium: "0 4px 5px 0 rgba(0, 0, 0, 0.14)",
  large: "0 6px 10px 0 rgba(0, 0, 0, 0.14)",
  largeX: "0 8px 10px 0 rgba(0, 0, 0, 0.14)",
  largeXX: "0 9px 12px 0 rgba(0, 0, 0, 0.14)",
  huge: "0 12px 17px 0 rgba(0, 0, 0, 0.14)",
  hugeX: "0 16px 24px 0 rgba(0, 0, 0, 0.14)",
  hugeXX: "0 24px 38px 0 rgba(0, 0, 0, 0.14)"
};
var avonDarkTheme = {
  color: color$2,
  borderRadius: borderRadius$2,
  button: button$2,
  heading1: heading1$2,
  heading2: heading2$2,
  heading3: heading3$2,
  heading4: heading4$2,
  heading5: heading5$2,
  heading6: heading6$2,
  subtitle1: subtitle1$2,
  subtitle2: subtitle2$2,
  body1: body1$2,
  body2: body2$2,
  caption: caption$2,
  overline: overline$2,
  opacity: opacity$2,
  size: size$2,
  typography: typography$2,
  spacing: spacing$2,
  elevation: elevation$2
};
var color$3 = {
  primary: "#de0085",
  onPrimary: "#ffffff",
  primaryLight: "#ff56b5",
  onPrimaryLight: "#000000",
  primaryDark: "#a70058",
  onPrimaryDark: "#ffffff",
  secondary: "#e9e9e9",
  onSecondary: "#333333",
  secondaryLight: "#ffffff",
  onSecondaryLight: "#333333",
  secondaryDark: "#b7b7b7",
  onSecondaryDark: "#333333",
  background: "#fafafa",
  onBackground: "#333333",
  surface: "#ffffff",
  onSurface: "#333333",
  highlight: "#000000",
  highEmphasis: "#333333",
  mediumEmphasis: "#777777",
  lowEmphasis: "#bbbbbb",
  link: "#227bbd",
  onLink: "#ffffff",
  success: "#569a32",
  onSuccess: "#ffffff",
  warning: "#fcc433",
  onWarning: "#333333",
  alert: "#e74627",
  onAlert: "#ffffff"
};
var borderRadius$3 = {
  none: 0,
  small: 2,
  medium: 4,
  large: 8
};
var button$3 = {
  "default": {
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: 1.23,
    lineHeight: 1.5
  }
};
var heading1$3 = {
  fontSize: 96,
  fontWeight: 400,
  letterSpacing: 0
};
var heading2$3 = {
  fontSize: 60,
  fontWeight: 400,
  letterSpacing: 0
};
var heading3$3 = {
  fontSize: 48,
  fontWeight: 400,
  letterSpacing: 0
};
var heading4$3 = {
  fontSize: 34,
  fontWeight: 400,
  letterSpacing: 0.27
};
var heading5$3 = {
  fontSize: 24,
  fontWeight: 400,
  letterSpacing: 0
};
var heading6$3 = {
  fontSize: 20,
  fontWeight: 500,
  letterSpacing: 0.24
};
var subtitle1$3 = {
  fontSize: 16,
  fontWeight: 500,
  letterSpacing: 0.13
};
var subtitle2$3 = {
  fontSize: 14,
  fontWeight: 500,
  letterSpacing: 0.11
};
var body1$3 = {
  fontSize: 16,
  fontWeight: 400,
  letterSpacing: 0.51
};
var body2$3 = {
  fontSize: 14,
  fontWeight: 400,
  letterSpacing: 0.22
};
var caption$3 = {
  fontSize: 12,
  fontWeight: 400,
  letterSpacing: 0.38
};
var overline$3 = {
  fontSize: 12,
  fontWeight: 500,
  letterSpacing: 1.92
};
var opacity$3 = {
  transparent: 0,
  lower: 0.04,
  veryLow: 0.08,
  low: 0.12,
  mediumLow: 0.16,
  disabledLow: 0.24,
  disabled: 0.32,
  medium: 0.48,
  mediumHigh: 0.56,
  high: 0.64,
  veryHigh: 0.8,
  opaque: 1
};
var size$3 = {
  none: 0,
  micro: 4,
  tiny: 8,
  small: 16,
  standard: 24,
  semi: 32,
  semiX: 40,
  medium: 48,
  mediumX: 56,
  large: 64,
  largeX: 72,
  largeXX: 80,
  largeXXX: 88,
  huge: 96,
  hugeX: 128,
  hugeXX: 144,
  hugeXXX: 192,
  veryHuge: 256
};
var typography$3 = {
  fontFamily: {
    primary: "Roboto",
    secondary: "sans-serif",
    branding: "Helvetica Now",
    code: "Roboto Mono"
  },
  lineHeight: {
    reset: 1,
    small: 1.25,
    medium: 1.5,
    large: 2
  },
  fontWeight: {
    regular: 400,
    medium: 500
  }
};
var spacing$3 = {
  none: 0,
  micro: 4,
  tiny: 8,
  small: 16,
  standard: 24,
  semi: 32,
  large: 48,
  xLarge: 64
};
var elevation$3 = {
  none: "none",
  micro: "0 1px 1px 0 rgba(0, 0, 0, 0.14)",
  tiny: "0 2px 2px 0 rgba(0, 0, 0, 0.14)",
  small: "0 3px 4px 0 rgba(0, 0, 0, 0.14)",
  medium: "0 4px 5px 0 rgba(0, 0, 0, 0.14)",
  large: "0 6px 10px 0 rgba(0, 0, 0, 0.14)",
  largeX: "0 8px 10px 0 rgba(0, 0, 0, 0.14)",
  largeXX: "0 9px 12px 0 rgba(0, 0, 0, 0.14)",
  huge: "0 12px 17px 0 rgba(0, 0, 0, 0.14)",
  hugeX: "0 16px 24px 0 rgba(0, 0, 0, 0.14)",
  hugeXX: "0 24px 38px 0 rgba(0, 0, 0, 0.14)"
};
var avonLightTheme = {
  color: color$3,
  borderRadius: borderRadius$3,
  button: button$3,
  heading1: heading1$3,
  heading2: heading2$3,
  heading3: heading3$3,
  heading4: heading4$3,
  heading5: heading5$3,
  heading6: heading6$3,
  subtitle1: subtitle1$3,
  subtitle2: subtitle2$3,
  body1: body1$3,
  body2: body2$3,
  caption: caption$3,
  overline: overline$3,
  opacity: opacity$3,
  size: size$3,
  typography: typography$3,
  spacing: spacing$3,
  elevation: elevation$3
};
var color$4 = {
  primary: "#f4ab34",
  onPrimary: "#333333",
  primaryLight: "#fefde8",
  onPrimaryLight: "#333333",
  primaryDark: "#ef8426",
  onPrimaryDark: "#333333",
  secondary: "#ff6b0b",
  onSecondary: "#000000",
  secondaryLight: "#fff8e1",
  onSecondaryLight: "#000000",
  secondaryDark: "#ff5808",
  onSecondaryDark: "#000000",
  background: "#121212",
  onBackground: "#ffffff",
  surface: "#333333",
  onSurface: "#ffffff",
  highlight: "#ffffff",
  highEmphasis: "#fafafa",
  mediumEmphasis: "#bbbbbb",
  lowEmphasis: "#777777",
  link: "#227bbd",
  onLink: "#ffffff",
  success: "#569a32",
  onSuccess: "#ffffff",
  warning: "#fcc433",
  onWarning: "#333333",
  alert: "#e74627",
  onAlert: "#ffffff"
};
var borderRadius$4 = {
  none: 0,
  small: 2,
  medium: 4,
  large: 8
};
var button$4 = {
  "default": {
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: 1.23,
    lineHeight: 1.5
  }
};
var heading1$4 = {
  fontSize: 96,
  fontWeight: 400,
  letterSpacing: 0
};
var heading2$4 = {
  fontSize: 60,
  fontWeight: 400,
  letterSpacing: 0
};
var heading3$4 = {
  fontSize: 48,
  fontWeight: 400,
  letterSpacing: 0
};
var heading4$4 = {
  fontSize: 34,
  fontWeight: 400,
  letterSpacing: 0.27
};
var heading5$4 = {
  fontSize: 24,
  fontWeight: 400,
  letterSpacing: 0
};
var heading6$4 = {
  fontSize: 20,
  fontWeight: 500,
  letterSpacing: 0.24
};
var subtitle1$4 = {
  fontSize: 16,
  fontWeight: 500,
  letterSpacing: 0.13
};
var subtitle2$4 = {
  fontSize: 14,
  fontWeight: 500,
  letterSpacing: 0.11
};
var body1$4 = {
  fontSize: 16,
  fontWeight: 400,
  letterSpacing: 0.51
};
var body2$4 = {
  fontSize: 14,
  fontWeight: 400,
  letterSpacing: 0.22
};
var caption$4 = {
  fontSize: 12,
  fontWeight: 400,
  letterSpacing: 0.38
};
var overline$4 = {
  fontSize: 12,
  fontWeight: 500,
  letterSpacing: 1.92
};
var opacity$4 = {
  transparent: 0,
  lower: 0.04,
  veryLow: 0.08,
  low: 0.12,
  mediumLow: 0.16,
  disabledLow: 0.24,
  disabled: 0.32,
  medium: 0.48,
  mediumHigh: 0.56,
  high: 0.64,
  veryHigh: 0.8,
  opaque: 1
};
var size$4 = {
  none: 0,
  micro: 4,
  tiny: 8,
  small: 16,
  standard: 24,
  semi: 32,
  semiX: 40,
  medium: 48,
  mediumX: 56,
  large: 64,
  largeX: 72,
  largeXX: 80,
  largeXXX: 88,
  huge: 96,
  hugeX: 128,
  hugeXX: 144,
  hugeXXX: 192,
  veryHuge: 256
};
var typography$4 = {
  fontFamily: {
    primary: "Roboto",
    secondary: "sans-serif",
    branding: "Helvetica Now",
    code: "Roboto Mono"
  },
  lineHeight: {
    reset: 1,
    small: 1.25,
    medium: 1.5,
    large: 2
  },
  fontWeight: {
    regular: 400,
    medium: 500
  }
};
var spacing$4 = {
  none: 0,
  micro: 4,
  tiny: 8,
  small: 16,
  standard: 24,
  semi: 32,
  large: 48,
  xLarge: 64
};
var elevation$4 = {
  none: "none",
  micro: "0 1px 1px 0 rgba(0, 0, 0, 0.14)",
  tiny: "0 2px 2px 0 rgba(0, 0, 0, 0.14)",
  small: "0 3px 4px 0 rgba(0, 0, 0, 0.14)",
  medium: "0 4px 5px 0 rgba(0, 0, 0, 0.14)",
  large: "0 6px 10px 0 rgba(0, 0, 0, 0.14)",
  largeX: "0 8px 10px 0 rgba(0, 0, 0, 0.14)",
  largeXX: "0 9px 12px 0 rgba(0, 0, 0, 0.14)",
  huge: "0 12px 17px 0 rgba(0, 0, 0, 0.14)",
  hugeX: "0 16px 24px 0 rgba(0, 0, 0, 0.14)",
  hugeXX: "0 24px 38px 0 rgba(0, 0, 0, 0.14)"
};
var naturaDarkTheme = {
  color: color$4,
  borderRadius: borderRadius$4,
  button: button$4,
  heading1: heading1$4,
  heading2: heading2$4,
  heading3: heading3$4,
  heading4: heading4$4,
  heading5: heading5$4,
  heading6: heading6$4,
  subtitle1: subtitle1$4,
  subtitle2: subtitle2$4,
  body1: body1$4,
  body2: body2$4,
  caption: caption$4,
  overline: overline$4,
  opacity: opacity$4,
  size: size$4,
  typography: typography$4,
  spacing: spacing$4,
  elevation: elevation$4
};
var color$5 = {
  primary: "#f4ab34",
  onPrimary: "#333333",
  primaryLight: "#fefde8",
  onPrimaryLight: "#333333",
  primaryDark: "#ef8426",
  onPrimaryDark: "#333333",
  secondary: "#ff6b0b",
  onSecondary: "#000000",
  secondaryLight: "#fff8e1",
  onSecondaryLight: "#000000",
  secondaryDark: "#ff5808",
  onSecondaryDark: "#000000",
  background: "#fafafa",
  onBackground: "#333333",
  surface: "#ffffff",
  onSurface: "#333333",
  highlight: "#000000",
  highEmphasis: "#333333",
  mediumEmphasis: "#777777",
  lowEmphasis: "#bbbbbb",
  link: "#227bbd",
  onLink: "#ffffff",
  success: "#569a32",
  onSuccess: "#ffffff",
  warning: "#fcc433",
  onWarning: "#333333",
  alert: "#e74627",
  onAlert: "#ffffff"
};
var borderRadius$5 = {
  none: 0,
  small: 2,
  medium: 4,
  large: 8
};
var button$5 = {
  "default": {
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: 1.23,
    lineHeight: 1.5
  }
};
var heading1$5 = {
  fontSize: 96,
  fontWeight: 400,
  letterSpacing: 0
};
var heading2$5 = {
  fontSize: 60,
  fontWeight: 400,
  letterSpacing: 0
};
var heading3$5 = {
  fontSize: 48,
  fontWeight: 400,
  letterSpacing: 0
};
var heading4$5 = {
  fontSize: 34,
  fontWeight: 400,
  letterSpacing: 0.27
};
var heading5$5 = {
  fontSize: 24,
  fontWeight: 400,
  letterSpacing: 0
};
var heading6$5 = {
  fontSize: 20,
  fontWeight: 500,
  letterSpacing: 0.24
};
var subtitle1$5 = {
  fontSize: 16,
  fontWeight: 500,
  letterSpacing: 0.13
};
var subtitle2$5 = {
  fontSize: 14,
  fontWeight: 500,
  letterSpacing: 0.11
};
var body1$5 = {
  fontSize: 16,
  fontWeight: 400,
  letterSpacing: 0.51
};
var body2$5 = {
  fontSize: 14,
  fontWeight: 400,
  letterSpacing: 0.22
};
var caption$5 = {
  fontSize: 12,
  fontWeight: 400,
  letterSpacing: 0.38
};
var overline$5 = {
  fontSize: 12,
  fontWeight: 500,
  letterSpacing: 1.92
};
var opacity$5 = {
  transparent: 0,
  lower: 0.04,
  veryLow: 0.08,
  low: 0.12,
  mediumLow: 0.16,
  disabledLow: 0.24,
  disabled: 0.32,
  medium: 0.48,
  mediumHigh: 0.56,
  high: 0.64,
  veryHigh: 0.8,
  opaque: 1
};
var size$5 = {
  none: 0,
  micro: 4,
  tiny: 8,
  small: 16,
  standard: 24,
  semi: 32,
  semiX: 40,
  medium: 48,
  mediumX: 56,
  large: 64,
  largeX: 72,
  largeXX: 80,
  largeXXX: 88,
  huge: 96,
  hugeX: 128,
  hugeXX: 144,
  hugeXXX: 192,
  veryHuge: 256
};
var typography$5 = {
  fontFamily: {
    primary: "Roboto",
    secondary: "sans-serif",
    branding: "Helvetica Now",
    code: "Roboto Mono"
  },
  lineHeight: {
    reset: 1,
    small: 1.25,
    medium: 1.5,
    large: 2
  },
  fontWeight: {
    regular: 400,
    medium: 500
  }
};
var spacing$5 = {
  none: 0,
  micro: 4,
  tiny: 8,
  small: 16,
  standard: 24,
  semi: 32,
  large: 48,
  xLarge: 64
};
var elevation$5 = {
  none: "none",
  micro: "0 1px 1px 0 rgba(0, 0, 0, 0.14)",
  tiny: "0 2px 2px 0 rgba(0, 0, 0, 0.14)",
  small: "0 3px 4px 0 rgba(0, 0, 0, 0.14)",
  medium: "0 4px 5px 0 rgba(0, 0, 0, 0.14)",
  large: "0 6px 10px 0 rgba(0, 0, 0, 0.14)",
  largeX: "0 8px 10px 0 rgba(0, 0, 0, 0.14)",
  largeXX: "0 9px 12px 0 rgba(0, 0, 0, 0.14)",
  huge: "0 12px 17px 0 rgba(0, 0, 0, 0.14)",
  hugeX: "0 16px 24px 0 rgba(0, 0, 0, 0.14)",
  hugeXX: "0 24px 38px 0 rgba(0, 0, 0, 0.14)"
};
var naturaLightTheme = {
  color: color$5,
  borderRadius: borderRadius$5,
  button: button$5,
  heading1: heading1$5,
  heading2: heading2$5,
  heading3: heading3$5,
  heading4: heading4$5,
  heading5: heading5$5,
  heading6: heading6$5,
  subtitle1: subtitle1$5,
  subtitle2: subtitle2$5,
  body1: body1$5,
  body2: body2$5,
  caption: caption$5,
  overline: overline$5,
  opacity: opacity$5,
  size: size$5,
  typography: typography$5,
  spacing: spacing$5,
  elevation: elevation$5
};
var color$6 = {
  primary: "#62b3ae",
  onPrimary: "#000000",
  primaryLight: "#94e5e0",
  onPrimaryLight: "#000000",
  primaryDark: "#2f837f",
  onPrimaryDark: "#000000",
  secondary: "#d2ad93",
  onSecondary: "#000000",
  secondaryLight: "#ffdfc4",
  onSecondaryLight: "#000000",
  secondaryDark: "#a07e65",
  onSecondaryDark: "#000000",
  background: "#121212",
  onBackground: "#ffffff",
  surface: "#333333",
  onSurface: "#ffffff",
  highlight: "#ffffff",
  highEmphasis: "#fafafa",
  mediumEmphasis: "#bbbbbb",
  lowEmphasis: "#777777",
  link: "#227bbd",
  onLink: "#ffffff",
  success: "#569a32",
  onSuccess: "#ffffff",
  warning: "#fcc433",
  onWarning: "#333333",
  alert: "#e74627",
  onAlert: "#ffffff"
};
var borderRadius$6 = {
  none: 0,
  small: 2,
  medium: 4,
  large: 8
};
var button$6 = {
  "default": {
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: 1.23,
    lineHeight: 1.5
  }
};
var heading1$6 = {
  fontSize: 96,
  fontWeight: 400,
  letterSpacing: 0
};
var heading2$6 = {
  fontSize: 60,
  fontWeight: 400,
  letterSpacing: 0
};
var heading3$6 = {
  fontSize: 48,
  fontWeight: 400,
  letterSpacing: 0
};
var heading4$6 = {
  fontSize: 34,
  fontWeight: 400,
  letterSpacing: 0.27
};
var heading5$6 = {
  fontSize: 24,
  fontWeight: 400,
  letterSpacing: 0
};
var heading6$6 = {
  fontSize: 20,
  fontWeight: 500,
  letterSpacing: 0.24
};
var subtitle1$6 = {
  fontSize: 16,
  fontWeight: 500,
  letterSpacing: 0.13
};
var subtitle2$6 = {
  fontSize: 14,
  fontWeight: 500,
  letterSpacing: 0.11
};
var body1$6 = {
  fontSize: 16,
  fontWeight: 400,
  letterSpacing: 0.51
};
var body2$6 = {
  fontSize: 14,
  fontWeight: 400,
  letterSpacing: 0.22
};
var caption$6 = {
  fontSize: 12,
  fontWeight: 400,
  letterSpacing: 0.38
};
var overline$6 = {
  fontSize: 12,
  fontWeight: 500,
  letterSpacing: 1.92
};
var opacity$6 = {
  transparent: 0,
  lower: 0.04,
  veryLow: 0.08,
  low: 0.12,
  mediumLow: 0.16,
  disabledLow: 0.24,
  disabled: 0.32,
  medium: 0.48,
  mediumHigh: 0.56,
  high: 0.64,
  veryHigh: 0.8,
  opaque: 1
};
var size$6 = {
  none: 0,
  micro: 4,
  tiny: 8,
  small: 16,
  standard: 24,
  semi: 32,
  semiX: 40,
  medium: 48,
  mediumX: 56,
  large: 64,
  largeX: 72,
  largeXX: 80,
  largeXXX: 88,
  huge: 96,
  hugeX: 128,
  hugeXX: 144,
  hugeXXX: 192,
  veryHuge: 256
};
var typography$6 = {
  fontFamily: {
    primary: "Roboto",
    secondary: "sans-serif",
    branding: "Helvetica Now",
    code: "Roboto Mono"
  },
  lineHeight: {
    reset: 1,
    small: 1.25,
    medium: 1.5,
    large: 2
  },
  fontWeight: {
    regular: 400,
    medium: 500
  }
};
var spacing$6 = {
  none: 0,
  micro: 4,
  tiny: 8,
  small: 16,
  standard: 24,
  semi: 32,
  large: 48,
  xLarge: 64
};
var elevation$6 = {
  none: "none",
  micro: "0 1px 1px 0 rgba(0, 0, 0, 0.14)",
  tiny: "0 2px 2px 0 rgba(0, 0, 0, 0.14)",
  small: "0 3px 4px 0 rgba(0, 0, 0, 0.14)",
  medium: "0 4px 5px 0 rgba(0, 0, 0, 0.14)",
  large: "0 6px 10px 0 rgba(0, 0, 0, 0.14)",
  largeX: "0 8px 10px 0 rgba(0, 0, 0, 0.14)",
  largeXX: "0 9px 12px 0 rgba(0, 0, 0, 0.14)",
  huge: "0 12px 17px 0 rgba(0, 0, 0, 0.14)",
  hugeX: "0 16px 24px 0 rgba(0, 0, 0, 0.14)",
  hugeXX: "0 24px 38px 0 rgba(0, 0, 0, 0.14)"
};
var theBodyShopDarkTheme = {
  color: color$6,
  borderRadius: borderRadius$6,
  button: button$6,
  heading1: heading1$6,
  heading2: heading2$6,
  heading3: heading3$6,
  heading4: heading4$6,
  heading5: heading5$6,
  heading6: heading6$6,
  subtitle1: subtitle1$6,
  subtitle2: subtitle2$6,
  body1: body1$6,
  body2: body2$6,
  caption: caption$6,
  overline: overline$6,
  opacity: opacity$6,
  size: size$6,
  typography: typography$6,
  spacing: spacing$6,
  elevation: elevation$6
};
var color$7 = {
  primary: "#004236",
  onPrimary: "#ffffff",
  primaryLight: "#356d60",
  onPrimaryLight: "#ffffff",
  primaryDark: "#001d10",
  onPrimaryDark: "#ffffff",
  secondary: "#a55f53",
  onSecondary: "#ffffff",
  secondaryLight: "#d98d7f",
  onSecondaryLight: "#ffffff",
  secondaryDark: "#73342a",
  onSecondaryDark: "#ffffff",
  background: "#fafafa",
  onBackground: "#333333",
  surface: "#ffffff",
  onSurface: "#333333",
  highlight: "#000000",
  highEmphasis: "#333333",
  mediumEmphasis: "#777777",
  lowEmphasis: "#bbbbbb",
  link: "#227bbd",
  onLink: "#ffffff",
  success: "#569a32",
  onSuccess: "#ffffff",
  warning: "#fcc433",
  onWarning: "#333333",
  alert: "#e74627",
  onAlert: "#ffffff"
};
var borderRadius$7 = {
  none: 0,
  small: 2,
  medium: 4,
  large: 8
};
var button$7 = {
  "default": {
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: 1.23,
    lineHeight: 1.5
  }
};
var heading1$7 = {
  fontSize: 96,
  fontWeight: 400,
  letterSpacing: 0
};
var heading2$7 = {
  fontSize: 60,
  fontWeight: 400,
  letterSpacing: 0
};
var heading3$7 = {
  fontSize: 48,
  fontWeight: 400,
  letterSpacing: 0
};
var heading4$7 = {
  fontSize: 34,
  fontWeight: 400,
  letterSpacing: 0.27
};
var heading5$7 = {
  fontSize: 24,
  fontWeight: 400,
  letterSpacing: 0
};
var heading6$7 = {
  fontSize: 20,
  fontWeight: 500,
  letterSpacing: 0.24
};
var subtitle1$7 = {
  fontSize: 16,
  fontWeight: 500,
  letterSpacing: 0.13
};
var subtitle2$7 = {
  fontSize: 14,
  fontWeight: 500,
  letterSpacing: 0.11
};
var body1$7 = {
  fontSize: 16,
  fontWeight: 400,
  letterSpacing: 0.51
};
var body2$7 = {
  fontSize: 14,
  fontWeight: 400,
  letterSpacing: 0.22
};
var caption$7 = {
  fontSize: 12,
  fontWeight: 400,
  letterSpacing: 0.38
};
var overline$7 = {
  fontSize: 12,
  fontWeight: 500,
  letterSpacing: 1.92
};
var opacity$7 = {
  transparent: 0,
  lower: 0.04,
  veryLow: 0.08,
  low: 0.12,
  mediumLow: 0.16,
  disabledLow: 0.24,
  disabled: 0.32,
  medium: 0.48,
  mediumHigh: 0.56,
  high: 0.64,
  veryHigh: 0.8,
  opaque: 1
};
var size$7 = {
  none: 0,
  micro: 4,
  tiny: 8,
  small: 16,
  standard: 24,
  semi: 32,
  semiX: 40,
  medium: 48,
  mediumX: 56,
  large: 64,
  largeX: 72,
  largeXX: 80,
  largeXXX: 88,
  huge: 96,
  hugeX: 128,
  hugeXX: 144,
  hugeXXX: 192,
  veryHuge: 256
};
var typography$7 = {
  fontFamily: {
    primary: "Roboto",
    secondary: "sans-serif",
    branding: "Helvetica Now",
    code: "Roboto Mono"
  },
  lineHeight: {
    reset: 1,
    small: 1.25,
    medium: 1.5,
    large: 2
  },
  fontWeight: {
    regular: 400,
    medium: 500
  }
};
var spacing$7 = {
  none: 0,
  micro: 4,
  tiny: 8,
  small: 16,
  standard: 24,
  semi: 32,
  large: 48,
  xLarge: 64
};
var elevation$7 = {
  none: "none",
  micro: "0 1px 1px 0 rgba(0, 0, 0, 0.14)",
  tiny: "0 2px 2px 0 rgba(0, 0, 0, 0.14)",
  small: "0 3px 4px 0 rgba(0, 0, 0, 0.14)",
  medium: "0 4px 5px 0 rgba(0, 0, 0, 0.14)",
  large: "0 6px 10px 0 rgba(0, 0, 0, 0.14)",
  largeX: "0 8px 10px 0 rgba(0, 0, 0, 0.14)",
  largeXX: "0 9px 12px 0 rgba(0, 0, 0, 0.14)",
  huge: "0 12px 17px 0 rgba(0, 0, 0, 0.14)",
  hugeX: "0 16px 24px 0 rgba(0, 0, 0, 0.14)",
  hugeXX: "0 24px 38px 0 rgba(0, 0, 0, 0.14)"
};
var theBodyShopLightTheme = {
  color: color$7,
  borderRadius: borderRadius$7,
  button: button$7,
  heading1: heading1$7,
  heading2: heading2$7,
  heading3: heading3$7,
  heading4: heading4$7,
  heading5: heading5$7,
  heading6: heading6$7,
  subtitle1: subtitle1$7,
  subtitle2: subtitle2$7,
  body1: body1$7,
  body2: body2$7,
  caption: caption$7,
  overline: overline$7,
  opacity: opacity$7,
  size: size$7,
  typography: typography$7,
  spacing: spacing$7,
  elevation: elevation$7
};
/* eslint-disable import/no-unresolved */
// @todo generate type definitions

var themes = {
  aesop: {
    dark: aesopDarkTheme,
    light: aesopLightTheme
  },
  avon: {
    dark: avonDarkTheme,
    light: avonLightTheme
  },
  natura: {
    dark: naturaDarkTheme,
    light: naturaLightTheme
  },
  theBodyShop: {
    dark: theBodyShopDarkTheme,
    light: theBodyShopLightTheme
  }
};
export default themes;